
    import { defineComponent } from 'vue'
    import XBreadcrumb from '@/apps/shared/components/breadcrumb.vue';
    import housingTypeService from '@/apps/shared/services/getHouseType-service';
    import BuildingSurfaceService from '@/apps/shared/services/getBuildingSurfaceLimits-service';
    import localityService from '@/apps/shared/services/locality-service';
    import webSaleHelper from '@/apps/shared/utils/webSaleHelper';

    export default defineComponent({
        components: {
            XBreadcrumb,
        },
        data() {
            return {
                isBack: false,
                breadcrumItems: [
                    { text: 'Inicio', path: '/hogar-premium' },
                    { text: 'Cotizá tu hogar', path: '/hogar-premium/cotizar' },
                ],
                localityList:
                    function (params) {
                        return localityService.getLocalityList(params)
                    },
                selectedLocality: null,
                cityId: null,
                zipCode: null,
                houseTypes: [{ id: "", text: "" }],
                articleCode: null,
                autocompleteConfig: {
                    formatResult: NF.Autocomplete.Result.TAGS,
                    selection: NF.Autocomplete.Result.TAGS,
                    minimumInputLength: 4
                },
                buildingSurfaceMin: null,
                buildingSurfaceMax: null,
                surfaceHouse: null,
                buildTypeCode: null,
                dataTwoTabJson: null,
                backExit: false,
                referente: null,
                medium: null,
                pas: null,
            }
        },
        methods: {
            async pageCustomization() {
                const defaultTitle = 'Hogar Premium';
                const actualPath = '/hogar-premium';
                // Llamamos al helper que se encarga de toda la lógica
                try {
                    await webSaleHelper.pageCustomization(this.$route, this.Bus, this.$store, defaultTitle, actualPath, null, null);
                    const title = this.$store.getters.getWebSaleData?.pageCustomization?.navbar?.title ?? '';
                    this.pas = title === defaultTitle ? null : title;
                }
                catch (error) {
                    const statusCode = error.response.status;
                    this.Bus.$emit(
                        'show-service-fail',
                        statusCode,
                        [() => this.pageCustomization()]);
                }
            },

            updateByProductGoogleAnalytics() {
                window.globalThis.dataLayer = window.globalThis.dataLayer || [];
                const productGtmName = 'DefaultFamilyCombinedGTMInfo';
                this.Bus.$emit('updateByProductGoogleAnalytics', productGtmName);
            },
            siguiente() {

                var validSelectedArticleCode = this.articleCode != null;
                var validSelectedSurfaceHouse = this.surfaceHouse != null;
                var validSelectedLocality = this.selectedLocality != null;
                if (validSelectedArticleCode && validSelectedSurfaceHouse && validSelectedLocality && ((this.surfaceHouse >= this.buildingSurfaceMin) && (this.surfaceHouse <= this.buildingSurfaceMax))) {
                    const eventData = {
                        'pas': this.pas,
                        'email': JSON.parse(sessionStorage.getItem("TabOneWelcome")).email,
                        'product': 'hogarPremium',
                        'event': 'cotizador-hogar-premium-datos-vivienda',
                        'referente': this.referente,
                        'medio': this.medium
                    };

                    window.globalThis.dataLayer = window.globalThis.dataLayer || [];
                    window.globalThis.dataLayer.push(eventData);

                    const customWindow = window as typeof window & {
                        _qsie?: Array<typeof eventData>;
                    };

                    customWindow._qsie ??= [];
                    customWindow._qsie.push(eventData);

                    var dataTwoTab = {
                        articleCode: this.articleCode,
                        surfaceHouse: this.surfaceHouse,
                        selectedLocality: this.selectedLocality,
                        buildTypeCode: this.buildTypeCode,
                        buildingSurfaceMin: this.buildingSurfaceMin,
                        buildingSurfaceMax: this.buildingSurfaceMax
                    }
                    sessionStorage.removeItem("TabTwoData");
                    sessionStorage.setItem("TabTwoData", JSON.stringify(dataTwoTab));
                    sessionStorage.setItem("FromPassTabTwo", "true");

                    this.$router.push({
                        name: 'tabThreeFamilyCombinedPremium',
                    })

                    NF.UI.Page.unblock();
                }
            },

            getHousingType() {
                housingTypeService.getHousingTypes().then((response) => {
                    if (response.length != 0) {
                        this.houseTypes = response.map(element =>
                            ({ ...element, id: element["article"], text: element["description"] }))
                    }
                });
            },

            getBuildingSurfaceLimits() {
                BuildingSurfaceService.getBuildingSurfaceLimits().then(buildingSurface => {
                    this.buildingSurfaceMin = buildingSurface["minLimit"];
                    this.buildingSurfaceMax = buildingSurface["maxLimit"];

                    NF.Validation.Field.addField('#formTabTwo', 'surfaceHouse', {
                        validators: {
                            between: {
                                min: this.buildingSurfaceMin,
                                max: this.buildingSurfaceMax
                            },
                        },
                    })
                });
            },

            isNumberKey(event) {
                var charCode = event.which ? event.which : event.keyCode;
                if (charCode > 31 && (charCode < 48 || charCode > 57)) {
                    event.preventDefault();
                }
            },

            volver() {
                sessionStorage.setItem("pressBack", "true");
                this.$router.push({
                    name: 'tabOneFamilyCombinedPremium',
                })
            },
            getInitData() {
                sessionStorage.setItem("ExitOrContinueModal", "true");
                NF.UI.Page.block();
                this.getHousingType();
                this.getBuildingSurfaceLimits();
                var validBack = sessionStorage.getItem("pressBack");
                if (validBack) {
                    sessionStorage.removeItem("pressBack");
                    this.backExit = true;
                }
                else {
                    this.isBack = false;
                    this.backExit = false;
                }
                var dataTwoTab = sessionStorage.getItem("TabTwoData");
                if (dataTwoTab != null) {
                    new Promise<any>(async (resolve) => {
                        await BuildingSurfaceService.getBuildingSurfaceLimits().then(async buildingSurface => {
                            this.buildingSurfaceMin = buildingSurface["minLimit"];
                            this.buildingSurfaceMax = buildingSurface["maxLimit"];
                            this.dataTwoTabJson = JSON.parse(dataTwoTab!);
                            this.articleCode = this.dataTwoTabJson.articleCode;
                            this.surfaceHouse = this.dataTwoTabJson.surfaceHouse;
                            this.selectedLocality = this.dataTwoTabJson.selectedLocality
                        })
                    })
                    NF.UI.Page.unblock();
                }
                else {
                    NF.UI.Page.unblock();
                }
            }
        },

        watch: {
            selectedLocality(newVal) {
                if (this.selectedLocality != null) {
                    this.localityIsSelected = true;
                    this.cityId = newVal.id;
                    this.zipCode = newVal.zipCode;
                }
            },
        },
        created() {
            window.globalThis.validateLocality = function () {
                return Boolean(this.selectedLocality);
            }.bind(this);
        },
        async mounted() {
            try {
                NF.UI.Page.block();

                var referente = sessionStorage.getItem("Referente");
                referente == 'null' || referente == null ? this.referente = null : this.referente = referente;
                var medium = sessionStorage.getItem("Medium");
                medium == 'null' || medium == null ? this.medium = 'organic' : this.medium = medium;

                const parallelPromises = [
                    this.pageCustomization(),
                    this.updateByProductGoogleAnalytics(),
                    this.getInitData()
                ];

                await Promise.all([
                    ...parallelPromises,
                ]);

            } finally {
                NF.UI.Page.unblock();
            }
        },
    })
